import styled from '@emotion/styled';

const PaymentScheduleStyle = styled('div')`
    font-size: 16px;
    .header {
        font-weight: bold;
        margin-bottom: 16px;
    }
    .box-values {
        .bold {
            font-weight: bold;
        }
        & > div {
            margin-bottom: 8px;
        }
        .text-right {
            text-align: right;
        }
    }
    .ant-form-item {
        margin-bottom: 12px;
        .ant-input {
            padding: 5px;
            border: 2px solid rgb(18, 184, 151);
            border-radius: 0;
            font-size: 14px;
            height: 32px;
            &.ant-input-status-error {
                border-color: #ff4d4f;
            }
        }
    }
    .btn-add {
        border-color: rgb(18, 184, 151);
        color: rgb(18, 184, 151);
    }
    @media screen and (max-width: 767px) {
        .box-step {
            display: flex;
            gap: 16px;
            .step-num {
                margin-bottom: 0px;
            }
        }
    }
`;
export default PaymentScheduleStyle;
